export default __webpack_public_path__ + "locales/lo-LA/InfoPanel.json?hash=247431957486302f7fae01fb6b9da32d";